import z from 'zod'
import { decimalSchema } from '../../utils/schema'

/** Backpack `BorrowLendEventType` の値一覧 */
export const borrowLendEventTypes = [
  'Borrow',
  'BorrowRepay',
  'Lend',
  'LendRedeem',
] as const

/**
 * Backpack `BorrowLendMovement` レスポンススキーマ。
 * `source` は Manual / AutoBorrowRepay / Withdrawal / Interest / Liquidation 等で、
 * 将来追加される可能性があるため文字列として受け取る。
 */
export const borrowLendMovementSchema = z.object({
  /** イベント種別 */
  eventType: z.enum(borrowLendEventTypes),
  /** 関連 borrow lend position の ID */
  positionId: z.string(),
  /** イベント適用後の position 数量 (running total) */
  positionQuantity: z.string(),
  /** イベントの数量 (絶対値) */
  quantity: decimalSchema,
  /** イベントの発生元 */
  source: z.string(),
  /** 対象アセットのシンボル */
  symbol: z.string(),
  /** イベント発生時刻 (naive ISO date-time, UTC) */
  timestamp: z.string(),
  /** spot margin 経由の場合の order ID */
  spotMarginOrderId: z.string().nullish(),
})

export const borrowLendMovementsResponseSchema = z.array(
  borrowLendMovementSchema,
)

export type BorrowLendMovement = z.infer<typeof borrowLendMovementSchema>
